import React from 'react'
import { NavLink } from 'react-router-dom';
import './Policys.css';

const RefundPolicy = () => {
  const navLinks = [
    { name: 'PRIVACY POLICY', path: '/PrivacyPolicy' },
    { name: 'REFUND POLICY', path: '/RefundPolicy' },
    { name: 'TERMS OF SERVICES', path: '/TermsService' },
  ];

  return (
    <div className="privacy-container">
      {/* Navigation Bar */}
      <nav className="nav-bar">
        {navLinks.map((link) => (
          <NavLink
            key={link.name}
            to={link.path}
            className={({ isActive }) => 
                isActive ? "nav-button active" : "nav-button"
            }
          >
            <span className="nav-text">{link.name}</span>
          </NavLink>
        ))}
      </nav>

     <main className="content-wrapper">
  <div className="page-header">
    <h1 className="page-title">Refund & Cancellation Policy</h1>
    <p className="page-subtitle">
      Important information regarding ticket cancellations and refunds
    </p>
  </div>

  {/* Overview */}
  <div className="section-row">
    <h2 className="section-title">Overview</h2>
    <div className="section-body">
      <p className="section-lead">
        At Event House, we curate experiences with limited capacity and careful
        planning. As a result, tickets once booked are generally non-refundable
        and non-cancellable.
      </p>
    </div>
  </div>

  {/* No Refund Policy */}
  <div className="section-row">
    <h2 className="section-title">No Routine Refunds or Cancellations</h2>
    <div className="section-body">
      <p>
        We do not offer refunds or cancellations for change of plans, no-shows,
        personal scheduling conflicts, or last-minute unavailability.
        Tickets are issued for a specific event, date, and time and are
        non-transferable unless explicitly stated otherwise.
      </p>
    </div>
  </div>

  {/* Exceptional Circumstances */}
  <div className="section-row">
    <h2 className="section-title">Exceptional Circumstances</h2>
    <div className="section-body">
      <p>
        Refund or cancellation requests may be considered only in extreme and
        unavoidable circumstances, such as the death of the attendee or an
        immediate family member. Valid supporting documentation will be required
        for verification.
      </p>
      <p>
        Approval of such requests is at the sole discretion of Event House.
      </p>
    </div>
  </div>

  {/* Event House Cancellation */}
  <div className="section-row">
    <h2 className="section-title">Event Cancellation by Event House</h2>
    <div className="section-body">
      <p>
        If an event is cancelled or rescheduled by Event House, attendees will be
        eligible for a full refund or an alternative option, as communicated at
        the time of cancellation.
      </p>
    </div>
  </div>

  {/* How to Request */}
  <div className="section-row">
    <h2 className="section-title">How to Request a Refund or Cancellation</h2>
    <div className="section-body">
      <p>
        All refund or cancellation requests must be submitted through the
        <strong> Contact Us </strong> or <strong> Raise a Ticket </strong> feature
        available on our platform. Requests made through other channels may not
        be considered.
      </p>
    </div>
  </div>

  {/* Processing Time */}
  <div className="section-row">
    <h2 className="section-title">Processing Time</h2>
    <div className="section-body">
      <p>
        Once a request is approved after verification, refunds (if applicable)
        will be processed within <strong>7–10 working days</strong> to the
        original mode of payment.
      </p>
    </div>
  </div>

  {/* Final Note */}
  <div className="section-row">
    <h2 className="section-title">Final Note</h2>
    <div className="section-body">
      <p>
        By booking a ticket and attending an Event House experience, you
        acknowledge and agree to this Refund & Cancellation Policy.
      </p>
    </div>
  </div>
</main>

    </div>
  )
}

export default RefundPolicy